export default __webpack_public_path__ + "static/media/mytel.e7d5f288.png";